/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 傳出去外部用 查詢員工職稱資訊-角色設定回傳資料
 */
export interface UserJobTitlesSearchInfoViewMode { 
    userJobTitleId?: string;
    jobTitleId?: string;
    jobTitleCode?: string;
    jobTitleName?: string;
    departmentId?: string;
    departmentCode?: string;
    departmentName?: string;
    userNo?: string;
    userName?: string;
    mainDuty?: string;
    priority?: number;
}